/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDimensionFromJSON, ApiDimensionToJSON, } from './ApiDimension';
import { ApiDimensionCategoryFromJSON, ApiDimensionCategoryToJSON, } from './ApiDimensionCategory';
export function ApiSimpleDimensionLabelFromJSON(json) {
    return ApiSimpleDimensionLabelFromJSONTyped(json, false);
}
export function ApiSimpleDimensionLabelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aiDescription': !exists(json, 'aiDescription') ? undefined : json['aiDescription'],
        'aiDisabled': !exists(json, 'aiDisabled') ? undefined : json['aiDisabled'],
        'article': !exists(json, 'article') ? undefined : json['article'],
        'category': !exists(json, 'category') ? undefined : ApiDimensionCategoryFromJSON(json['category']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'dimension': !exists(json, 'dimension') ? undefined : ApiDimensionFromJSON(json['dimension']),
        'hasArticle': !exists(json, 'hasArticle') ? undefined : json['hasArticle'],
        'hidden': !exists(json, 'hidden') ? undefined : json['hidden'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}
export function ApiSimpleDimensionLabelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aiDescription': value.aiDescription,
        'aiDisabled': value.aiDisabled,
        'article': value.article,
        'category': ApiDimensionCategoryToJSON(value.category),
        'description': value.description,
        'dimension': ApiDimensionToJSON(value.dimension),
        'hasArticle': value.hasArticle,
        'hidden': value.hidden,
        'label': value.label,
    };
}
